var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68234 11.6823C12.356 11.6823 14.5235 9.51484 14.5235 6.84115C14.5235 4.16746 12.356 2 9.68234 2C7.00864 2 4.84119 4.16746 4.84119 6.84115C4.84119 9.51484 7.00864 11.6823 9.68234 11.6823Z",
    fill: "#4E5968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4932 12.9168C10.2269 12.9047 9.96067 12.8926 9.6823 12.8926C6.7534 12.8926 4.01815 13.7035 1.6823 15.0953C0.617247 15.7247 0 16.9107 0 18.1573V21.3646H11.2073C10.2511 19.997 9.6823 18.3268 9.6823 16.5234C9.6823 15.2284 9.98487 14.0181 10.4932 12.9168Z",
    fill: "#4E5968"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6929 16.5234C22.6929 16.2571 22.6566 16.015 22.6202 15.7609L24 14.5385L22.7897 12.4447L21.0348 13.0377C20.6475 12.711 20.2118 12.4568 19.7277 12.2753L19.3646 10.4719H16.944L16.5809 12.2753C16.0968 12.4568 15.6611 12.711 15.2738 13.0377L13.5189 12.4447L12.3086 14.5385L13.6883 15.7609C13.652 16.015 13.6157 16.2571 13.6157 16.5234C13.6157 16.7896 13.652 17.0317 13.6883 17.2858L12.3086 18.5082L13.5189 20.602L15.2738 20.009C15.6611 20.3358 16.0968 20.5899 16.5809 20.7715L16.944 22.5748H19.3646L19.7277 20.7715C20.2118 20.5899 20.6475 20.3358 21.0348 20.009L22.7897 20.602L24 18.5082L22.6202 17.2858C22.6566 17.0317 22.6929 16.7896 22.6929 16.5234ZM18.1543 18.9439C16.823 18.9439 15.7337 17.8547 15.7337 16.5234C15.7337 15.192 16.823 14.1028 18.1543 14.1028C19.4856 14.1028 20.5749 15.192 20.5749 16.5234C20.5749 17.8547 19.4856 18.9439 18.1543 18.9439Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/MyAccount.fb562665449ad4ab7d4dc31ea17c5877.svg";
export { ForwardRef as ReactComponent };